import styles from './index.module.scss'
import Utils from '@utils/utils'
import { TYPETITLEMAP, IMAGE_TYPE } from '@utils/CONST'
import { Badge } from 'antd';
import { LoadingOutlined, CloseOutlined } from '@ant-design/icons';


const TaskMenuItem = (props) => {
    const { item, onClick, recentId, selectedTaskListId } = props
    const GeneratingPage = (
        <div className={styles.Dpage}>
            <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/loadingGray.gif" alt="" />
        </div>
    )

    return (
        <Badge dot={item.unread} >
            <div
                id={`task-item-${item.id}`}
                className={`${styles.TaskMenuItem}
             ${selectedTaskListId == item.id ? styles.TaskMenuItemBorder : null}`}
                onClick={() => onClick(item)} >
                <span className={styles.leftTopIcon}>{item?.imageType == IMAGE_TYPE.SIM_TRYON ? '同版型': TYPETITLEMAP[item?.imageType]}</span>
                <img src={Utils.getImgThumbnail(item?.mainImage?.split(',')[0])} alt="" />
                {item.status === 'failed' && <CloseOutlined className={styles.failedIcon} />}
                {
                    (item.status === 'processing' ||
                        item.status === 'pending' ||
                        item.status === 'started') && GeneratingPage
                }
                {
                    recentId == item.id && <div className={styles.TaskMenuItem_} ><LoadingOutlined /></div>
                }
            </div>
        </Badge>

    )
}

export default TaskMenuItem